import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface PostInterface {
    id: number;
    title: string;
    date: string;
    abstract: string;
}


function usePostNavigation() {
    const [selectedPost, setSelectedPost] = useState<PostInterface | null>(null);
    const navigate = useNavigate();

    const openPostPage = (post: PostInterface) => {
        setSelectedPost(post);
        navigate(`/post/${post.id}`, { state: { post } });
    };

    return { selectedPost, openPostPage };
}

export default usePostNavigation;
